import { Canvas, Image, ImageResource } from '@tencent/alloy-renderer';
import { ChartEditLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/pc-edit/logic/chart-edit-logic';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { addSyncTask } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/utils';

export interface ChartPlotComponentProps {
    width: number;
    height: number;
    resource: { data: HTMLElement } | ImageResource<any>;
    factoryOptions: InterfaceFactoryOptions;
    afterResourceTransform?: () => void;
    enableResourceTransform?: boolean;
}

// 绘图区
export class ChartPlotComponent extends Image {
    public factoryOptions: InterfaceFactoryOptions;
    public props: ChartPlotComponentProps;
    private imageResource: ImageResource | null;
    private enableResourceTransform: boolean;

    public constructor(props: ChartPlotComponentProps) {
        super();

        this.updateProps(props);
    }

    public updateProps(props: ChartPlotComponentProps) {
        this.props = props;
        const { height, width, resource, factoryOptions, enableResourceTransform = false } = this.props;

        this.factoryOptions = factoryOptions;
        this.width = width;
        this.height = height;
        this.enableResourceTransform = enableResourceTransform;

        if (this.resource === resource) {
            return;
        }

        // 更新的时候重置imageResource
        this.imageResource = null;
        this.resource = resource as ImageResource;

        if (enableResourceTransform) {
            addSyncTask(() => {
                this.transformResourceToImage();
            });
        }
    }

    // todo try catch
    public transformResourceToImage = (): Promise<void> => new Promise((
        resolve,
        reject,
    ) => {
        const sourceCanvas = this.resource?.data;
        if (sourceCanvas) {
            // TODO 需要处理一下 crash或者 还没完成就更新了的情况，需要做一次 产物校验
            try {
                (sourceCanvas as HTMLCanvasElement).toBlob(async (blob) => {
                    if (blob) {
                        const url = URL.createObjectURL(blob);
                        const imageResource: ImageResource = new ImageResource(new Promise((resolve) => {
                            const img = new window.Image();
                            img.src = url;
                            img.onload = () => resolve(img);
                        }));

                        imageResource.onImageLoaded(() =>  {
                            this.imageResource = imageResource;

                            this.props.afterResourceTransform?.();
                            URL.revokeObjectURL(url);
                            resolve();
                        });
                    }
                });
            } catch (err) {
                reject(err);
            }
        }
    });

    protected draw(canvas: Canvas): void {
        const resource = this.imageResource || this.resource;

        if (!resource || (resource as ImageResource).isEmpty) {
            return;
        }

        canvas.drawImage(
            resource as ImageResource,
            0, 0, this.width, this.height,
        );
    }
}
